import { Button } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { ShareIcon } from 'components/icons';
import React, { useCallback } from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { useTenantSession } from 'utils/sessionProvider';
import { WebShareButton_node$key } from './__generated__/WebShareButton_node.graphql';

interface WebShareButtonProps {
  node: WebShareButton_node$key;
}

export const WebShareButton = ({ node: nodeRef }: WebShareButtonProps) => {
  const {
    canonicalUrl: url,
    name,
    __typename,
  } = useFragment(nodeFragment, nodeRef);
  const {
    tenant: { name: tenantName },
  } = useTenantSession();
  const webShareAvailable = url && window.navigator.share;

  let title = name;

  if (!title) {
    switch (__typename) {
      case 'Announcement':
        title = t`An announcement on ${tenantName}`;
        break;
    }
  }

  const handleOnClick = useCallback(async () => {
    try {
      await window.navigator.share({
        title,
        url,
      });
    } catch (e) {
      console.warn(e);
    }
  }, [url, name]);

  if (!webShareAvailable) {
    return <></>;
  }

  return (
    <Button
      size="sm"
      w="100%"
      rightIcon={<ShareIcon />}
      justifyContent="space-between"
      onClick={handleOnClick}
    >
      {t`More share options`}
    </Button>
  );
};

const nodeFragment = graphql`
  fragment WebShareButton_node on Node {
    ... on HasCanonicalUrlInterface {
      canonicalUrl
    }
    ... on FolderNodeInterface {
      __typename
      name
    }
    ... on Event {
      __typename
      name
    }
    ... on Vault {
      __typename
      name
    }
    ... on VaultItem {
      __typename
      name
    }
    ... on Space {
      __typename
      name
    }
    ... on Announcement {
      __typename
    }
  }
`;
